const PRIVATE_TEAMS_PATH = /^\/api\/v5\/events\/(\d{15,21})\/groups\/(\d{15,21})\/teams\/?$/;
/** Le site public expose la même route que l'API : seule `accounts.wls.gg` accepte le Bearer. */
const ACCEPTED_HOSTS = new Set(["accounts.wls.gg", "www.wls.gg", "wls.gg"]);

export function parsePrivateWlsTeamsUrl(value: string) {
  let url: URL;
  try {
    url = new URL(value.trim());
  } catch {
    return null;
  }
  if (url.protocol !== "https:" || !ACCEPTED_HOSTS.has(url.hostname) || url.search || url.hash) return null;
  const match = url.pathname.match(PRIVATE_TEAMS_PATH);
  return match ? { eventId: match[1], groupId: match[2] } : null;
}

/** URL `accounts.wls.gg` équivalente, ou `null` si la saisie n'est pas une route d'équipes WLS. */
export function canonicalPrivateWlsTeamsUrl(value: string): string | null {
  const ids = parsePrivateWlsTeamsUrl(value);
  return ids ? `https://accounts.wls.gg/api/v5/events/${ids.eventId}/groups/${ids.groupId}/teams` : null;
}
